import { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AuthProviderV2 from "./providers/auth-provider-v2";
import { pornesteAcordCookie } from "./core/consent/cookie-consent";
import { laNavigare, pornesteVerificareaVersiunii } from "./core/version/versiune-noua";

/**
 * App - Root component for all routes
 *
 * Provides:
 * - AuthProviderV2: Authentication context (uses useLocation/useNavigate - needs router context)
 * - Suspense: Loading fallback for lazy-loaded routes
 * - Outlet: Renders child routes (layouts)
 * - ToastContainer: Global toast notifications
 */
export default function App() {
    // Bannerul de cookie-uri: o data pe incarcare (functia e idempotenta), sub router, ca sa nu se
    // remonteze la navigare. Pana la acord, App Insights ruleaza fara cookie-uri.
    useEffect(() => {
        pornesteAcordCookie();
        pornesteVerificareaVersiunii();
    }, []);

    // Un tab ramas deschis peste un deploy: la schimbarea rutei verificam daca s-a publicat alt
    // build si, daca da, reincarcam la navigarea urmatoare (`core/version/versiune-noua.ts`).
    const location = useLocation();
    useEffect(() => {
        laNavigare(location.state);
    }, [location.key]);

    return (
        <AuthProviderV2>
            <Suspense
                fallback={
                    <div className="flex items-center justify-center h-screen bg-gray-50">
                        <div className="text-center">
                            <div className="text-lg font-medium text-gray-700">
                                Se încarcă...
                            </div>
                        </div>
                    </div>
                }
            >
                <Outlet />
            </Suspense>
            {/*
             * ToastContainer sta IN AFARA lui <Suspense>, intentionat. Toate rutele cu `lazy: true`
             * suspenda exact aceasta granita la fiecare navigare (main.jsx creeaza un `React.lazy`
             * per ruta), iar cat timp se vede fallback-ul React ascunde/reface intreg subarborele
             * primar. Cu containerul inauntru, stratul de toast-uri era demontat si reconstruit fix
             * in fereastra in care un flux „toast de succes -> navigare" isi trimite toast-ul
             * (react-toastify re-emite `toast.update` cu delay 100 ms si isi tine coada de asteptare
             * la nivel de modul, rejucata la fiecare montare a containerului). Afara, stratul de
             * notificari supravietuieste tranzitiilor de ruta.
             */}
            {/* `pointerEvents` NU se mai forteaza inline: stilul inline bate regula din
              `main.css` care face containerul transparent la clicuri. Containerul
              acoperea hamburgerul la 360 — patru din cinci puncte de hit-test
              ajungeau la toast, deci meniul nu se putea deschide. */}
            <ToastContainer />
        </AuthProviderV2>
    );
}
